/**
 * Name Normalization Utility (Frontend)
 * Normalizes names to proper case format: "First Middle Last"
 * - Converts all caps to proper case
 * - Capitalizes first letter of each word
 */

/**
 * Normalize a name string
 * - Converts all caps to proper case
 * - Capitalizes first letter of each word
 * - Handles multiple words (First Middle Last)
 * 
 * @param {string} name - The name to normalize
 * @returns {string} - The normalized name
 */
export function normalizeName(name) {
  if (!name || typeof name !== 'string') {
    return name;
  }

  // Trim whitespace
  name = name.trim();

  // If empty, return as is
  if (!name) {
    return name;
  }

  // Check if name has letters
  const hasLetters = /[a-zA-Z]/.test(name);
  if (!hasLetters) {
    return name; // No letters to normalize
  }

  // Check if all letters are uppercase
  const allCaps = name === name.toUpperCase() && /[A-Z]/.test(name);
  
  // If all caps, convert to proper case
  if (allCaps) {
    // Split by spaces and capitalize first letter of each word
    return name
      .split(/\s+/)
      .map(word => {
        if (!word) return word;
        // Capitalize first letter, lowercase the rest
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  // If not all caps, still normalize to proper case (First Letter Of Each Word)
  return name
    .split(/\s+/)
    .map(word => {
      if (!word) return word;
      // Capitalize first letter, lowercase the rest
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

